import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';

import colors from '../../constants/Colors';

export default function CustomModalRedesigned({
  title,
  afterClose,
  onCloseClicked,
  visible,
  children,
  width = 400,
  maskColor = colors.MODAL_MASK_DARK,
  hideCloseButton = false,
  getContainer = () => document.body,
  destroyOnClose = false,
  zIndex = 1010,
}) {
  return (
    <Modal
      visible={visible}
      footer={null}
      afterClose={afterClose}
      maskStyle={{
        backgroundColor: maskColor,
      }}
      bodyStyle={{ padding: 24, paddingTop: title ? 24 : 36 }}
      maskClosable
      closable={!hideCloseButton}
      onCancel={onCloseClicked}
      onCloseClicked={onCloseClicked}
      width={width}
      centered
      getContainer={getContainer}
      destroyOnClose={destroyOnClose}
      zIndex={zIndex}
      title={title}
    >
      {children}
    </Modal>
  );
}

CustomModalRedesigned.propTypes = {
  title: PropTypes.string,
  afterClose: PropTypes.func,
  onCloseClicked: PropTypes.func,
  visible: PropTypes.bool,
  children: PropTypes.node,
  width: PropTypes.number,
  maskColor: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  getContainer: PropTypes.func,
  destroyOnClose: PropTypes.bool,
  zIndex: PropTypes.number,
};

CustomModalRedesigned.defaultProps = {
  title: '',
  afterClose: () => {},
  onCloseClicked: () => {},
  visible: false,
  children: null,
  width: 400,
  maskColor: colors.MODAL_MASK_DARK,
  hideCloseButton: false,
  getContainer: () => document.body,
  destroyOnClose: false,
  zIndex: 1010,
};
